import { Outlet } from 'react-router-dom';
import DashboardSidebar from '@components/dashboard/DashboardSidebar';
import Header from '@components/layout/Header';
import { useState } from 'react';

const DashboardLayout = () => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);

    return (
        <div className="min-h-screen bg-secondary-50">
            {/* Main Header */}
            <Header />

            <div className="flex"> {/* Add padding-top to account for fixed header */}
                <DashboardSidebar
                    isOpen={isSidebarOpen}
                    onClose={() => setIsSidebarOpen(false)}
                />

                <div className="flex-1 lg:pl-64 w-full">
                    <main className="pt-28 md:pt-32 py-8 px-4 sm:px-6 lg:px-8">
                        <Outlet />
                    </main>
                </div>
            </div>
        </div>
    );
};

export default DashboardLayout;
